import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import ConsumablesActions, { ConsumablesRedux, ContractsTypes } from '../Redux/ConsumablesRedux'

const consumablesCRUDObservable = createCRUDObservable({
  mainRedux: ConsumablesRedux,
  reduxPath: 'consumables',
})

const getStudentConsumablesEpic = (action$, store, { Api }) => (
  action$.ofType(ContractsTypes.getStudentConsumablesRequest)
    .mergeMap(({ centerId, studentId }) => (
      Observable
        .fromPromise(Api.consumables.get(centerId, { student_id: studentId })
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          const { status } = response

          if (!(status >= 200 && status < 300)) {
            return [
              ConsumablesActions.getStudentConsumablesError(response.error),
            ]
          }

          return [
            ConsumablesActions.getStudentConsumablesSuccess(response.data.data),
          ]
        })
    ))
)

export const consumablesObservers = Object.assign({}, consumablesCRUDObservable.observers, {})


export const consumablesEpic = combineEpics(
  consumablesCRUDObservable.epic,
  getStudentConsumablesEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/ConsumablesObservable.js